import React from 'react';
import { Typography } from '@mui/material';
import { formatDate } from '@/utils/constants';

/** Each log level's label and text colour. */
const LOG_LEVELS = {
	info: { label: 'Info', color: 'text.secondary' },
	warning: { label: 'Warning', color: 'warning.main' },
	error: { label: 'Error', color: 'error.main' },
};

/**
 * The user import log table's columns: each entry's time, level (warnings and errors in
 * colour) and message. None sort: a log reads in the order it was written.
 */
export const userImportLogColumns = [
	{
		field: 'at',
		headerName: 'Time',
		width: 200,
		hideable: false,
		sortable: false,
		valueFormatter: (value) => formatDate(value, true),
	},
	{
		field: 'level',
		headerName: 'Level',
		width: 110,
		sortable: false,
		valueFormatter: (value) => LOG_LEVELS[value].label,
		renderCell: ({ value }) => (
			<Typography variant='body2' color={LOG_LEVELS[value].color}>
				{LOG_LEVELS[value].label}
			</Typography>
		),
	},
	{
		field: 'message',
		headerName: 'Message',
		flex: 1,
		minWidth: 300,
		sortable: false,
		renderCell: ({ value, row }) => (
			<Typography
				variant='body2'
				color={row.level === 'info' ? 'text.primary' : LOG_LEVELS[row.level].color}
				sx={{ whiteSpace: 'normal', wordBreak: 'break-word' }}
			>
				{value}
			</Typography>
		),
	},
];
